/* MapleWeld - policy pages (table of contents, heading clean-up) + FAQ search. */
(function () {
  'use strict';
  function txt(el) { return el.textContent.replace(/\s+/g, ' ').trim(); }

  /* Old policy text was pasted in with bold lines instead of real headings.
     Turn those into h2 / h3 so the page has structure and a table of contents. */
  function promote(root) {
    var cands = root.querySelectorAll('p > strong:first-child, p > b:first-child, li > strong:first-child, li > b:first-child');
    Array.prototype.forEach.call(cands, function (b) {
      var par = b.parentElement, prev = b.previousSibling;
      while (prev && prev.nodeType === 3 && !prev.textContent.trim()) prev = prev.previousSibling;
      if (prev) return;
      var t = txt(b);
      if (t.length < 3 || t.length > 110 || /[.!?]$/.test(t)) return;
      var nx = b.nextSibling;
      while (nx && nx.nodeType === 3 && !nx.textContent.trim()) nx = nx.nextSibling;
      if (nx && nx.nodeName !== 'BR' && !b.querySelector('br')) return;
      var colon = /:$/.test(t);
      if (colon && par.tagName === 'LI') return;
      var h = document.createElement(colon ? 'h3' : 'h2');
      h.textContent = t.replace(/:$/, '');
      b.remove();
      while (par.firstChild && (par.firstChild.nodeName === 'BR' || (par.firstChild.nodeType === 3 && !par.firstChild.textContent.trim()))) par.removeChild(par.firstChild);
      if (par.tagName === 'P') {
        par.before(h);
        if (!par.textContent.trim() && !par.querySelector('a,img')) par.remove();
      } else {
        par.classList.add('mwp-sec');
        par.prepend(h);
      }
    });
  }

  /* "SECTION 3 - ONLINE STORE TERMS" -> "3. Online Store Terms" for the contents list. */
  function label(t) {
    var m = t.match(/^SECTION\s+(\d+)\s*[-–]\s*(.*)$/i), n = '', s = t;
    if (m) { n = m[1] + '. '; s = m[2]; }
    if (s === s.toUpperCase() && /[A-Z]/.test(s)) {
      s = s.toLowerCase().replace(/(^|[\s(\/-])([a-z])/g, function (x, a, b) { return a + b.toUpperCase(); })
           .replace(/\s(And|Of|The|Or|To|If)\s/g, function (x) { return x.toLowerCase(); });
    }
    return n + s;
  }

  function initPolicy(root) {
    Array.prototype.forEach.call(root.querySelectorAll('h1'), function (h) {
      var n = document.createElement('h2'); n.innerHTML = h.innerHTML; h.replaceWith(n);
    });
    if (root.querySelectorAll('h2').length < 3) promote(root);
    Array.prototype.forEach.call(root.querySelectorAll('p'), function (p) {
      if (!p.textContent.trim() && !p.querySelector('img,a,iframe')) p.remove();
    });
    var grid = root.closest('.mwp__grid');
    var toc = grid && grid.querySelector('[data-mwp-toc]');
    var heads = root.querySelectorAll('h2');
    if (!toc || heads.length < 3) { if (grid) grid.classList.add('no-toc'); return; }
    var ol = toc.querySelector('ol'), links = [];
    Array.prototype.forEach.call(heads, function (h, i) {
      var t = txt(h);
      h.id = 'mwp-' + (t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 's') + '-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = label(t);
      li.appendChild(a); ol.appendChild(li); links.push(a);
    });
    if (window.matchMedia('(min-width:1001px)').matches) toc.open = true;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-on', a.hash === '#' + e.target.id); });
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      Array.prototype.forEach.call(heads, function (h) { io.observe(h); });
    }
  }

  function initFaq(box) {
    var input = box.querySelector('[data-mwf-q]'), items = box.querySelectorAll('.mwf__item'),
        groups = box.querySelectorAll('.mwf__group'), empty = box.querySelector('.mwf__empty'),
        count = box.querySelector('.mwf__count');
    if (!input) return;
    var total = items.length;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), shown = 0;
      Array.prototype.forEach.call(items, function (it) {
        var ok = !q || it.textContent.toLowerCase().indexOf(q) > -1;
        it.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      Array.prototype.forEach.call(groups, function (g) {
        g.style.display = g.querySelector('.mwf__item:not([style*="none"])') ? '' : 'none';
      });
      if (empty) empty.style.display = shown ? 'none' : 'block';
      if (count) count.textContent = q ? shown + ' of ' + total + ' questions' : total + ' questions';
    });
  }

  function boot() {
    var on = document.querySelector('.mwp__chip.is-on'), nav = on && on.parentElement;
    if (nav && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = on.offsetLeft - 16;
    var p = document.querySelector('[data-mwp-prose]'); if (p) initPolicy(p);
    var f = document.querySelector('[data-mwf]'); if (f) initFaq(f);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();